<template>
  <v-container>
    <div class="text-right">
      <v-switch
        v-model="$vuetify.theme.dark"
        label="Dark Mode"
      ></v-switch>
    </div>
    <v-card class="pa-4 my-2">
      <v-card-title>Example buttons</v-card-title>
      <v-btn v-for="c in colors" :key="c + '_b1'" class="mx-2" :color="c">{{ c }}</v-btn>
      <br />
      <br />
      <v-btn v-for="c in colors" :key="c + '_b2'" class="mx-2" :color="c" outlined>{{ c }}</v-btn>
    </v-card>
    <v-card class="pa-4 my-2">
      <v-card-title>Typography Colors</v-card-title>
      <span v-for="c in colors" :class="c + '--text mx-3'" :key="c + '_p1'">{{ c }}</span>
    </v-card>
    <v-card class="pa-4 my-2">
      <v-card-title>Typography Colors</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
              <p class="font-weight-black">
                Black text.
              </p>
              <p class="font-weight-bold">
                Bold text.
              </p>
              <p class="font-weight-medium">
                Medium weight text.
              </p>
              <p class="font-weight-regular">
                Normal weight text.
              </p>
              <p class="font-weight-light">
                Light weight text.
              </p>
              <p class="font-weight-thin">
                Thin weight text.
              </p>
              <p class="font-italic">
                Italic text.
              </p>
          </v-col>
          <v-col cols="12" md="6">
            <p class="text-h5 font-weight-bold black--text">
              Welcome to monday.com
            </p>
            <p class="text-h1">
              Heading 1
            </p>
            <p class="text-h2">
              Heading 2
            </p>
            <p class="text-h3">
              Heading 3
            </p>
            <p class="text-h4">
              Heading 4
            </p>
            <p class="text-h5">
              Heading 5
            </p>
            <p class="text-h6">
              Heading 6
            </p>
            <p class="text-subtitle-1">
              subtitle-1
            </p>
            <p class="text-subtitle-2">
              subtitle-2
            </p>
            <p class="text-body-1">
              body-1
            </p>
            <p class="text-body-2">
              body-2
            </p>
          </v-col>
        </v-row>
      </v-card-text>
      <v-text-field 
        label="test"
        v-model="fileData.amt"
        outlined
        placeholder=" "
      ></v-text-field>
      <v-text-field 
        label="test"
        v-model="fileData.amt2"
        outlined
        placeholder=" "
      ></v-text-field>
      <!-- <v-text-field 
        label="test"
        outlined
        :value="getPrincipalAndInterest(400000, 360, 2.5, false)"
        placeholder=" "
      ></v-text-field>
      <v-text-field
        v-model="fileData.subProp.appraisedValue"
        label="Property Value"
        :rules="[required, currency]"
        prefix="$"
        hide-details="auto"
        outlined
        dense
      ></v-text-field>
      <v-text-field
        v-model="fileData.loan.purPrice"
        label="Sale Price"
        @change="cc"
        :rules="[required, currency]"
        prefix="$"
        hide-details="auto"
        outlined
        dense
      ></v-text-field>
      <v-text-field
        v-model="fileData.loan.baseLoan"
        v-mask="$store.state.mask.currency"
        label="Loan Amount"
        prefix="$"
        hide-details="auto"
        outlined
        dense
      ></v-text-field> 
      <div class="v-input v-input--hide-details v-input--is-label-active v-input--is-dirty v-input--dense theme--light v-text-field v-text-field--prefix v-text-field--is-booted v-text-field--enclosed v-text-field--outlined">
      <input
        type="text"
        v-model="fileData.loan.baseLoan"
        v-mask="$store.state.mask.currency"
      />
      </div>
      <v-text-field
        v-model="fileData.loan.ltv"
        label="LTV"
        :rules="[required, percent]"
        suffix="%"
        hide-details="auto"
        outlined
        dense
      ></v-text-field>
      <v-text-field
        v-model="fileData.loan.cltv"
        label="CLTV"
        :rules="[required, percent]"
        suffix="%"
        hide-details="auto"
        outlined
        dense
      ></v-text-field> -->
    </v-card>
    <v-card class="pa-4 my-2">
      <v-card-title>Text Field</v-card-title>
    </v-card>
  </v-container>
</template>

<script>
import { common, convert, rules } from "@/mixins";

export default {
  name: "UIComponents",
  watch: {
    'fileData.amt': function(newVal, oldVal) {
      console.log(newVal);
      console.log(oldVal);
    }
  },
  data(){
    return {
      fileData: {
        // subProp: {
        //   appraisedValue: null,
        // },
        // loan: {
        //   purPrice: null,
        //   baseLoan: null,
        //   ltv: null,
        //   cltv: null,
        // },
        amt: null,
        amt2: null,
      },
      colors: [
        "default",
        "primary",
        "secondary",
        "warning",
        "success",
        "info",
        "error",
        "accent",
      ],
    }
  },
  methods: {
    toggleDarkMode() {
      this.$store.commit("TOGGLE_DARK_MODE");
      this.$vuetify.theme.dark = this.$store.state.appSettings.darkMode;
    },
    downloadPdf(fileURL, fileName){
      // for non-IE
      if (!window.ActiveXObject) {
          var save = document.createElement('a');
          save.href = fileURL;
          save.target = '_blank';
          save.download = fileName || 'unknown';

          var evt = new MouseEvent('click', {
              'view': window,
              'bubbles': true,
              'cancelable': false
          });
          save.dispatchEvent(evt);

          (window.URL || window.webkitURL).revokeObjectURL(save.href);
      }
    }
  },
  mixins: [common, convert, rules],
}
</script>